module.exports = __webpack_public_path__ + "img/沈阳稀蜴.4b17a8b7.png";